import { render, staticRenderFns } from "./messageIQIcon.vue?vue&type=template&id=31591424&scoped=true"
var script = {}
import style0 from "./messageIQIcon.vue?vue&type=style&index=0&id=31591424&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31591424",
  null
  
)

export default component.exports